export function getCookie(c_name) {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        const [name, value] = cookies[i].split("=");

        if (name.trim() === c_name) {
            return value.trim().length>0 ? decodeURIComponent(value) : "";
        }
    }

    return "";
}
export function checkCookie(cookiename) {
    const username = getCookie(cookiename);

    if (username) {
        return username;
    } else {
        showMsg("Not Set", "");
    }
}